// Generated by `npm run data:towed-bleaching` (scripts/data/towedBleaching.ts): the share of Maui Nui's bleaching coral
// that was pale, from NOAA's towed divers off Maui and Lānaʻi in November 2015, data/crep-towed-bleaching-0157624/.
// Do not edit by hand. tests/towedBleaching.test.ts builds it again.

/**
 * Of the coral pale or bleached, the share pale, not white: 359 divers' estimates on 186 segments of 21 tows off
 * Maui and Lānaʻi, 1.5 to 10.2 m deep, 3 to 10 November 2015, each weighed by its segment's live coral
 * (35.2% of it pale or bleached); 0.543175 to 0.634637 over the tows drawn again (4,000 draws, 95%).
 */
export const PALE_SHARE = 0.592888;
